import classNames from 'classnames';
import styles from './DepositSelectSum.module.scss';
import { useState } from 'react';

import { EBaseTextSize, EBaseTextWeight } from '@spinwise/react-component-library/BaseText';
import { ButtonLibrary } from 'Libraries/buttons.library';
import { Trans } from 'react-i18next';
import { amountToCurrency, currencyToAmount } from 'Utils/index';
import { IDepositSelectSum } from '../types';
import { useRegType } from 'Hooks/useRegType';
import { EBrandTextColor } from 'Libraries/typography.library';
import { ButtonTextOnly } from '@spinwise/react-component-library/ButtonTextOnly';
import {
  EBaseButtonSize,
  EBaseButtonTypeAttribute,
  EButtonBorderRadiusStrength,
  EButtonTextAlign,
} from '@spinwise/react-component-library/ButtonAbstract';
import { ButtonGuardText } from '@spinwise/react-component-library/ButtonGuardText';
import { EGuardAnimations } from '@spinwise/react-component-library/ButtonCommon';
import { RegTypes } from 'Types/globals';
import { useSelector } from 'react-redux';
import { IApplicationState } from '@spinwise/spinwise-core';

const DepositSelectSum = ({
  MIN_DEP_AMOUNT,
  selectedValue,
  sumArray,
  setSelectedValue,
  onAmountSelected,
  onClickButton,
  onClickMobileInput,
  typeLabel,
}: IDepositSelectSum) => {
  const [prevValue, setPrevValue] = useState(selectedValue);
  const [playAnim, setPlayAnim] = useState('');

  const isRegType = useRegType();
  const emailRegType = isRegType(RegTypes.EMAIL);
  const def_currency = useSelector((state: IApplicationState) => state.globalReducer.geo.def_currency);

  //@ts-ignore
  const minDepAmount = (
    <Trans components={{ MIN_DEP_AMOUNT: <span>{MIN_DEP_AMOUNT}</span> }} transKeepBasicHtmlNodesFor>
      {'warning.min.dep.amount'}
    </Trans>
  ) as any;
  const amountAsFloat = parseFloat(selectedValue?.toString()) || 0;

  const adjustValue = ({ isIncrement }: { isIncrement: boolean }) => {
    let newValue = Number(selectedValue || 0);

    if (newValue >= 1000) {
      newValue += isIncrement ? 1000 : -1000;
    } else if (newValue >= 500) {
      newValue += isIncrement ? 100 : -100;
    } else if (newValue >= 100) {
      newValue += isIncrement ? 50 : -50;
    } else {
      newValue += isIncrement ? 10 : -10;
    }

    if (isIncrement) {
      setSelectedValue(newValue > 10000 ? 10000 : newValue);
    } else {
      setSelectedValue(newValue < MIN_DEP_AMOUNT ? MIN_DEP_AMOUNT : newValue);
    }
  };

  return (
    <>
      <div className={`${styles.deposit_container}  jc-fs ai-c fl-d-c`}>
        <div className={styles.deposit_container__wrapper}>
          {sumArray &&
            sumArray.length > 0 &&
            sumArray.map(sum => {
              return (
                <div
                  key={sum}
                  onClick={() => {
                    onAmountSelected(sum);
                    setPlayAnim('');
                  }}
                  className={classNames(styles.deposit_container__wrapper_btn, {
                    [`${styles.deposit_container__wrapper_btn__selected}`]: selectedValue == sum,
                  })}
                >
                  <p>{`€${sum}`}</p>
                </div>
              );
            })}
        </div>

        <div className={`d-fl jc-sb ai-c fl-d-c ${styles.deposit_container__sum}`}>
          <div className={classNames('d-fl jc-sb ai-c w-100', styles.deposit_container__sum__wrapper)}>
            {!emailRegType && (
              <div className={styles.button__wrapper}>
                <ButtonTextOnly
                  alignText={EButtonTextAlign.Center}
                  borderRadius={EButtonBorderRadiusStrength.Eight}
                  size={EBaseButtonSize.Medium}
                  type={ButtonLibrary.KeyboardButton}
                  onClick={() => adjustValue({ isIncrement: false })}
                  textWeight={EBaseTextWeight.W500}
                  textSize={EBaseTextSize.Title4}
                  textColor={EBrandTextColor.White06}
                  fullWidth={true}
                  label="-"
                />
              </div>
            )}
            <div
              onAnimationEnd={() => {
                setPlayAnim('');
              }}
              className={`${styles.deposit_container_sum_input} ${playAnim}`}
            >
              <input
                className={styles.deposit_input_first}
                placeholder={selectedValue?.toString()}
                type="text"
                value={amountToCurrency(selectedValue, def_currency)}
                onFocus={() => {
                  setPrevValue(selectedValue);
                  //onAmountSelected('');
                }}
                onBlur={e => {
                  if (currencyToAmount(e.target.value) == '') {
                    onAmountSelected(prevValue?.toString());
                  }
                }}
                onChange={e => {
                  onAmountSelected(currencyToAmount(e.target.value));
                }}
                onClick={() => {
                  onAmountSelected('');
                }}
              />
              <input
                className={styles.deposit_input_second}
                placeholder={selectedValue?.toString()}
                type="text"
                value={amountToCurrency(MIN_DEP_AMOUNT, def_currency)}
                onFocus={() => {
                  setPrevValue(selectedValue);
                  //onAmountSelected('');
                }}
                onBlur={e => {
                  if (e.target.value == '') {
                    onAmountSelected(prevValue?.toString());
                  }
                }}
                onChange={e => {
                  onAmountSelected(currencyToAmount(e.target.value));
                }}
              />
              <div
                onClick={() => {
                  onClickMobileInput();
                }}
              >
                <input
                  disabled
                  className={styles.deposit_input_mobile}
                  value={amountToCurrency(selectedValue, def_currency)}
                />
              </div>
              <div
                onClick={() => {
                  onClickMobileInput();
                }}
              >
                <input disabled className={styles.deposit_input_mobile} value={MIN_DEP_AMOUNT} />
              </div>
            </div>
            {!emailRegType && (
              <div className={styles.button__wrapper}>
                <ButtonTextOnly
                  alignText={EButtonTextAlign.Center}
                  borderRadius={EButtonBorderRadiusStrength.Eight}
                  size={EBaseButtonSize.Medium}
                  type={ButtonLibrary.KeyboardButton}
                  onClick={() => adjustValue({ isIncrement: true })}
                  textWeight={EBaseTextWeight.W500}
                  textSize={EBaseTextSize.Title4}
                  textColor={EBrandTextColor.White06}
                  fullWidth={true}
                  label="+"
                />
              </div>
            )}
          </div>
          <div className="w-100">
            {selectedValue == null || amountAsFloat < MIN_DEP_AMOUNT ? (
              <ButtonGuardText
                label={typeLabel}
                size={EBaseButtonSize.Small}
                type={ButtonLibrary.Tertiary}
                borderRadius={EButtonBorderRadiusStrength.Five}
                typeAttribute={EBaseButtonTypeAttribute.Submit}
                fullWidth={true}
                alignText={EButtonTextAlign.Center}
                textSize={EBaseTextSize.Title4}
                textWeight={EBaseTextWeight.W500}
                guardText={{
                  value: minDepAmount,
                  size: EBaseTextSize.Title4,
                  weight: EBaseTextWeight.W500,
                }}
                guardAnimation={EGuardAnimations.UpDown}
                onGuardAnimationEnd={e => {
                  setSelectedValue(MIN_DEP_AMOUNT);
                  setPlayAnim('');
                }}
                onClick={() => {
                  setPlayAnim(styles.play_anim);
                }}
              ></ButtonGuardText>
            ) : (
              <ButtonTextOnly
                label={typeLabel}
                size={EBaseButtonSize.Small}
                textWeight={EBaseTextWeight.W500}
                textSize={EBaseTextSize.Title4}
                type={ButtonLibrary.Tertiary}
                borderRadius={EButtonBorderRadiusStrength.Five}
                typeAttribute={EBaseButtonTypeAttribute.Submit}
                fullWidth={true}
                alignText={EButtonTextAlign.Center}
                onClick={() => {
                  onClickButton();
                }}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DepositSelectSum;
